import {
    navigateToSqlEditor,
    navigateToUnionEditor,
    navigateToJoinEditor,
    navigateToWorkbench,
    navigateToExtractJsonEditor,
    navigateToMultiJoinEditor,
    navigateToQueryBuilder,
    navigateToFilter
} from 'app/routes/routes.js';
import {
    COMBINE_TYPE,
    QUERY_BUILDER_TYPE,
    JOIN_TYPE,
    TRANSFORMATION_STACK_DTO_TYPE,
    SQL_VIEW_DTO_TYPE
} from 'app/store/__generated__/types';
import { GET_VIEW_OPERATION } from 'app/store/__generated__/operations';
import { EXTRACT_JSON, FILTER, GROUP_NODE, MULTI_JOIN } from 'app/lib/constants';
import { transformView } from 'app/store/transformers.js';
import { selectEntityByPropId } from 'app/store/entities/selectors.js';
import { doSelectOperation } from 'app/store/operations/actions.js';
import { doToggleGroup } from 'app/store/flow/actions.js';
import { EDIT_VIEW, GET_VIEW } from './types.js';
import { selectCurrentViewId } from './selectors.js';

export const doGetView = ({ viewId, spaceId }) => ({
    type: GET_VIEW,
    api: { ...GET_VIEW_OPERATION, sync: true },
    params: { viewId, spaceId },
    transformer: ({ data }) => ({ ...data, viewDto: transformView(data.viewDto) })
});

export const doEditView = ({ entityId, type }) => ({
    type: EDIT_VIEW,
    effect: ({ store }) => {
        const state = store.getState();
        const view = selectEntityByPropId(state, { entityId });

        switch (type) {
            case SQL_VIEW_DTO_TYPE:
                navigateToSqlEditor(view.spaceSlug, view.slug);
                break;
            case COMBINE_TYPE:
                navigateToUnionEditor(view.spaceSlug, view.slug);
                break;
            case JOIN_TYPE:
                navigateToJoinEditor(view.spaceSlug, view.slug);
                break;
            case EXTRACT_JSON:
                navigateToExtractJsonEditor(view.spaceSlug, view.slug);
                break;
            case FILTER:
                navigateToFilter(view.spaceSlug, view.slug);
                break;
            case MULTI_JOIN:
                navigateToMultiJoinEditor(view.spaceSlug, view.slug);
                break;
            case TRANSFORMATION_STACK_DTO_TYPE: {
                const currentViewId = selectCurrentViewId(state);
                const index = view.operationUids.length - 1;

                if (entityId !== currentViewId) {
                    navigateToWorkbench(
                        view.spaceSlug,
                        view.uid,
                        {},
                        { editOperationIndex: index }
                    );
                } else {
                    store.dispatch(doSelectOperation(index));
                }
                break;
            }
            case QUERY_BUILDER_TYPE:
                navigateToQueryBuilder(view.spaceSlug, view.slug);
                break;
            case GROUP_NODE: {
                store.dispatch(doToggleGroup(view.entityId));
                break;
            }
            default:
        }
    }
});
